module.exports = __webpack_public_path__ + "img/file-binary-fill.9168b2ff.svg";